export default __webpack_public_path__ + "static/media/favorite-filled.e400bfd4.svg";